import UrlAlias from 'umg-ember-backend/components/record-explorer/for/url-alias';

<template><UrlAlias @records={{@model}} @recordType='url-alias' /></template>
